import React from "react";
import { MdDeleteOutline, MdInfoOutline } from "react-icons/md";

const ConfirmationModal = ({
  isOpen,
  message,
  onConfirm,
  onCancel,
  isDelete,
}) => {
  if (!isOpen) return null;

  const handleOutsideClick = (event) => {
    if (event.target.id === "modal-overlay") {
      onCancel();
    }
  };

  // 방법 1: split을 사용해서 각 줄을 별도로 렌더링
  const renderMessage = (text) => {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div
      id="modal-overlay"
      className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
      onClick={handleOutsideClick}
      style={{ position: "fixed" }}
    >
      <div
        className="bg-white p-4 rounded-lg shadow-2xl text-center max-w-sm min-w-[270px] border border-gray-200"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 상단 아이콘: 삭제 여부에 따라 아이콘 변경 */}
        <div className="flex justify-center items-center my-2">
          <div
            className={`text-4xl ${isDelete ? "text-red-500" : "text-primary"}`}
          >
            {isDelete ? <MdDeleteOutline /> : <MdInfoOutline />}
          </div>
        </div>

        {/* 텍스트 - 줄바꿈 처리 */}
        <p className="text-gray-800 text-sm mb-4">{renderMessage(message)}</p>

        {/* 버튼 그룹 */}
        <div className="flex justify-center space-x-2">
          <button onClick={onCancel} className="btn btn-sm btn-secondary px-4">
            <span>취소</span>
          </button>
          <button onClick={onConfirm} className="btn btn-sm btn-primary px-4">
            <span>확인</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
